
import { toNumber } from 'lodash'

export default function cleanDate(date) {
    return toNumber(date) ? toNumber(date) : date
}